import {
  Children,
  FunctionComponent,
  ComponentPropsWithoutRef,
  ReactNode
} from 'react';
import { Link } from 'react-router-dom';
import ReactGA from "react-ga4";

import { Button } from '../button';

import './LinkButton.light.scss';
import './LinkButton.dark.scss';

type ButtonProps = ComponentPropsWithoutRef<typeof Button>;

interface Props {
  to: string;
  children: ReactNode;
  className?: string;
  openInNewTab?: boolean;
  style?: ButtonProps['style'];
  color?: ButtonProps['color'];
  analyticsCategory?: string;
  analyticsAction?: string;
  analyticsLabel?: string;
  analyticsGeneralAction?: string;
  analyticsGeneralLabel?: string;
}

export function LinkButton(props: Props) {
  const children = Children.map(props.children, (child) =>
    typeof child !== 'string' ? child : <span>{child}</span>
  );

  const handleClick = () => {
    const { analyticsAction, analyticsCategory, analyticsLabel, analyticsGeneralAction, analyticsGeneralLabel } = props;
    if (analyticsAction && analyticsCategory && analyticsLabel) {
      ReactGA.event({
        category: analyticsCategory,
        action: analyticsAction,
        label: analyticsLabel
      })
      if (analyticsGeneralAction && analyticsGeneralLabel) {
        ReactGA.event({
          category: analyticsCategory,
          action: analyticsGeneralAction,
          label: analyticsGeneralLabel
        })
      }
    }
  }
  if (props.openInNewTab) {
    return (
      <a
        className={`link-button button ${props.className ? props.className + ' ' : ''
          }style--${props.style} color--${props.color}`}
        href={props.to}
        target='_blank'
        rel='noreferrer'
        onClick={handleClick}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      to={props.to}
      className={`link-button button ${props.className ? props.className + ' ' : ''
        }style--${props.style} color--${props.color}`}
    >
      {children}
    </Link>
  );
}

(LinkButton as FunctionComponent<Props>).defaultProps = {
  openInNewTab: false,
  style: 'basic',
  color: 'primary'
};
